import styled from 'styled-components';

import Container from '../../Core/Container';

export const Section = styled.section`
  background-color: ${({ theme, backgroundColor }) =>
    theme.colors[backgroundColor]};
  padding: 30px 0;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 40px 0;
  }

  + div {
    div.title-with-statement {
      margin: 2rem auto 3rem;
    }
  }
`;

export const Grid = styled(Container)`
  margin-top: 0;
  margin-bottom: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  ${Section}.velvet & {
    a {
      color: ${({ theme }) => theme.colors.white};

      &:hover,
      &:focus {
        opacity: 0.8;
      }
    }
  }

  a {
    margin: 8px 12.5px;
    font-size: 14px;
    line-height: 20px;
  }

  @media only screen and (max-width: 500px) {
    a:nth-of-type(1n + 4) {
      display: none;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    a {
      font-size: 16px;
      line-height: 20px;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    a {
      margin: 0 24px;
      font-size: 18px;
      line-height: 22px;
    }
  }
`;
